import { useMemo, type ReactNode } from "react";
import { AccessContext, accessFrom, useMeAccessQuery } from "./access.js";

/**
 * A-W4-WEB1 (W4 Schritt 3+4) — stellt die EINE Zugriffsantwort in den Baum.
 *
 * Montiert in `main.tsx` direkt unter `<SessionProvider>`: erst wenn eine
 * Session steht, gibt es einen Akteur, dessen Zugriff der Server rechnen kann.
 * Die Kinder rendern sofort — `can()` gewaehrt waehrend der ersten Abfrage
 * nichts (fail closed), statt die App hinter einem Ladebildschirm zu halten.
 *
 * Der Wert ist genau die Serverantwort — seit Schritt 4 ohne jede Rolle.
 *
 * Eigene Datei, damit `lib/access.ts` ohne JSX bleibt und kein Zyklus
 * `SessionProvider -> access -> SessionProvider` entsteht.
 */
export function AccessProvider({ children }: { children: ReactNode }) {
  const query = useMeAccessQuery();
  const value = useMemo(
    () => accessFrom(query.data, query.isPending),
    [query.data, query.isPending],
  );
  return <AccessContext.Provider value={value}>{children}</AccessContext.Provider>;
}
